import type { IntegrationPrepareResult } from '../../../models/IntegrationRun';
import { buildSmokeTestFlow } from '../utils/buildSmokeTestFlow';
import type { StepResult } from '@/pages/TechChecks/models';
import { API_INTEGRATION_TEST_BUSINESS_URL } from '@/utils';
import { runFlow } from '@/pages/TechChecks/utils/runner';
import type { RootState } from '@/store/store';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

const useSmokeTests = () => {
  const sessionToken = useSelector((state: RootState) => state.auth.auth.accessToken);
  const [results, setResults] = useState<StepResult[]>([]);

  const run = useCallback(
    async (prepare: IntegrationPrepareResult): Promise<StepResult[]> => {
      const flow = buildSmokeTestFlow(prepare, API_INTEGRATION_TEST_BUSINESS_URL);
      const finished: StepResult[] = [];
      setResults([]);

      await runFlow(
        flow,
        { sessionToken: sessionToken ?? '', variables: flow.variables },
        {
          onStepStart: (result) => setResults([...finished, result]),
          onStepEnd: (result) => {
            finished.push(result);
            setResults([...finished]);
          },
        },
        () => false
      );
      return finished;
    },
    [sessionToken]
  );

  return { run, results };
};

export default useSmokeTests;
